<template>
  <div>
    <!-- <meta name="viewport" content="width=device-width,initial-scale=1.0" /> -->
    <sub-head
      class="content banner web"
      subTitle="인지 평가 게임"
      subImg="cognitive_top"
    ></sub-head>
    <sub-head
      class="content banner mobile"
      subTitle="인지 평가 게임"
    ></sub-head>
    <div class="page_padding">
      <bread-crumb :path="$route"></bread-crumb>
    </div>

    <div class="page_padding">
      <div class="cognitive-title p-relative paddingT text-center">
        <span class="font34 line-height3 word_break title gray"
          >시니어의 인지력을 평가하기 위한 <br />기능성 게임
          <span class="textOrange">'그때 그시절 여름방학 이야기'</span>
        </span>
      </div>
      <div class="text-center paddingTop40 marginBottom40">
        <span class="font18 word_break sub-content deepGray line-height2"
          >기존의 딱딱하고 지루한 인지평가 방식을 벗어나 재미있고 친근하게
          인지평가를 할 수 있는 기능성 게임
        </span>
      </div>
    </div>
    <div class="page_padding paddingTop40 content marginB">
      <div style="display:flex; justify-content: space-between">
        <div style="width: 49%">
          <image-component
            :is_jpg="true"
            path=""
            name="cognitive_img01"
          ></image-component>
        </div>
        <div style="width: 49%">
          <image-component
            :is_jpg="true"
            path=""
            name="cognitive_img02"
          ></image-component>
        </div>
      </div>
      <div class="verticalSpacer-half"></div>
      <div style="display:flex; justify-content: space-between">
        <div style="width: 32%">
          <image-component
            :is_jpg="true"
            path=""
            name="cognitive_img03"
          ></image-component>
        </div>
        <div style="width: 32%">
          <image-component
            :is_jpg="true"
            path=""
            name="cognitive_img04"
          ></image-component>
        </div>
        <div style="width: 32%">
          <image-component
            :is_jpg="true"
            path=""
            name="cognitive_img05"
          ></image-component>
        </div>
      </div>
    </div>
    <div class="p-relative  text-center" style="background-color: #F6EFE8">
      <div class="page_padding content info">
        <p>인지 평가 게임 소개</p>
        <span class="font18 word_break sub-content block deepGray"
          >올바른 인지훈련을 위해서는 현재의 인지능력을 정확히
          평가해야합니다.</span
        >
      </div>
      <div class="cognitive page_padding">
        <div
          class="info-block"
          v-for="(item, index) in cognitiveContents"
          :key="index"
        >
          <image-component
            :is_jpg="false"
            path=""
            :name="item.path"
          ></image-component>
          <div class="cognitive-content-wrapper">
            <div class="text-left font34">
              <span class="fontBold word_break">{{ item.headline }}</span>
            </div>
            <div class="verticalSpacer-half"></div>
            <div class="text-left">
              <span class="fontS word_break sub-content">{{
                item.content
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_padding text-center marginB">
      <div class="content info">
        <p>인지평가 데이터 및 관리</p>
        <span class="font18 word_break sub-content"
          >인지평가 게임의 플레이 데이터를 수집, 분석하여 상세한 결과를
          사용자에게 제공합니다.
        </span>
      </div>
      <div class="cognitive-img-container">
        <div class="cognitive-img-wrapper">
          <image-component
            :is_jpg="true"
            name="cognitive_data_img01"
          ></image-component>
        </div>
        <div class="cognitive-img-wrapper">
          <image-component
            :is_jpg="true"
            name="cognitive_data_img02"
          ></image-component>
        </div>
      </div>
    </div>
    <div class="cognitive-item-wrapper ">
      <div class="page_padding content">
        <div class="cognitive-item-flex">
          <div
            class="cognitive-item"
            v-for="(item, index) in cognitiveDataManagement"
            :key="index"
          >
            <div class="icon-wrapper">
              <image-component
                :is_jpg="false"
                :name="item.path"
              ></image-component>
            </div>
            <div class="content-wrapper">
              <div class="content-header">
                <span class="font20 textWhite fontExtraBold word_break">{{
                  item.headline
                }}</span>
              </div>
              <div class="content-main">
                <span class="font14 textWhite word_break sub-content">{{
                  item.content
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTopContents from "@/assets/source/json/sub_top.json";
import CognitiveContents from "@/assets/source/json/happytable_cognitiveGame.json";
import CognitiveDataManagement from "@/assets/source/json/cognitive_data_management.json";
import ImageComponent from "@/components/imageComponent.vue";
import SubHead from "@/components/sub_head.vue";
import BreadCrumb from "../../components/BreadCrumb.vue";

export default {
  components: {
    SubHead,
    ImageComponent,
    BreadCrumb,
  },
  data() {
    return {
      content: subTopContents,
      cognitiveContents: CognitiveContents,
      cognitiveDataManagement: CognitiveDataManagement,
    };
  },
  methods: {
    getImgSrc(name) {
      var images;
      images = require.context("@/assets/source/images/", false, /\.png$/);
      return images("./" + name + ".png");
    },
  },
};
</script>

<style scoped>
.mobile {
  display: none;
}
.background-page {
  background-color: #f2f4f6;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
}
.d-flex-reverse {
  display: flex;
  flex-direction: row-reverse;
}
.cognitive {
  padding-bottom: 3rem !important;
}
.cognitive .info-block {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 78px;
  align-items: center;
  padding: 35px 60px;
  box-shadow: 0px 3px 6px #5e331529;
  margin-bottom: 3rem;
  background-color: #ffff;
  .imgWrap {
    max-width: 400px;
  }
}
.cognitive-image-wrapper {
  width: 40%;
}
.cognitive-content-wrapper {
  padding: 1rem 2rem;
  width: 100%;
  max-width: 400px;
}
.cognitive-img-container {
  display: flex;
  justify-content: space-between;
}
.cognitive-img-wrapper {
  width: 48%;
}
.cognitive-item-wrapper {
  padding: 5rem 0;
  background-image: url("../../assets/source/images/cognitive_bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.cognitive-content-wrapper .font34 {
  font-size: 28px;
}
.cognitive-title .line-height3 {
  line-height: 3.5rem;
}
.cognitive-item-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.cognitive-item {
  width: 25%;
  min-width: 250px;
}
.cognitive-item >>> img {
  display: block;
}
.icon-wrapper {
  width: 30%;
  margin: 0 auto;
  background-color: white;
  border-radius: 50%;
  padding: 2rem;
}
.content-wrapper {
  padding: 1rem 1rem 2rem 1rem;
}
.content-header {
  margin-bottom: 1rem;
}
.cognitive-info-wrapper {
  background-color: #e7e7e7;
  padding: 1rem 0;
}
.cognitive-info-wrapper .content {
  color: #dc375d;
}
.content.info {
  padding: 5rem 0 !important;
}
.content p {
  font-size: 41px;
  font-weight: bold;
  padding-bottom: 2.5rem;
}
.marginB {
  margin-bottom: 100px;
}

@media (max-width: 767px) {
  div.banner.web {
    margin-top: 60px;
    .banner-title {
      line-height: 2rem;
    }
  }
}
</style>
